<template>
  <!-- About -->
  <div class="about-sec">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="about-img d-none d-md-block">
            <div class="about-exp">
              <span>12+ years of experiences</span>
            </div>
            <div class="abt-img">
              <img
                src="@/assets/img/providers/provider-23.jpg"
                class="img-fluid"
                alt="img"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="about-content">
            <h6>ABOUT OUR COMPANY</h6>
            <h2>Best Solution For Cleaning Services</h2>
            <p>
              Welcome to Truelysell, your premier destination for connecting with
              top-rated service providers and finding the perfect match for your needs.
              Our platform is designed to simplify the process of discovering, evaluating,
              and hiring trusted professionals across a wide range of services, from home
              improvement and IT support to personal care and more.
            </p>
            <p>
              At Truelysell, our mission is to bridge the gap between service providers
              and customers by offering a seamless and efficient marketplace experience.
              We aim to empower both parties by providing a reliable platform where
              quality, transparency, and customer satisfaction are our top priorities.
            </p>
            <div class="row">
              <div class="col-md-6">
                <ul>
                  <li class="text-truncate">
                    <i class="ti ti-circle-check-filled text-dark me-1"></i>We prioritize
                    quality and reliability
                  </li>
                  <li class="text-truncate">
                    <i class="ti ti-circle-check-filled text-dark me-1"></i>WeSaving your
                    time and effort.
                  </li>
                </ul>
              </div>
              <div class="col-md-6">
                <ul>
                  <li class="text-truncate">
                    <i class="ti ti-circle-check-filled text-dark me-1"></i>Clear,
                    detailed service listings & reviews
                  </li>
                  <li class="text-truncate">
                    <i class="ti ti-circle-check-filled text-dark me-1"></i> Smooth and
                    satisfactory experience.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /About -->

  <!-- Work Section -->
  <section class="work-section px-0 my-0 work-bg">
    <div class="work-bg-2 d-none d-md-block">
      <img src="@/assets/img/bg/dotted.png" alt="img" class="img-fluid" />
    </div>
    <div class="work-bg-1 d-none d-md-block">
      <img src="@/assets/img/bg/bg-12.png" alt="img" class="img-fluid" />
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading">
            <h2>How It Works</h2>
            <p>
              Straightforward process designed to make your experience seamless and
              hassle-free.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 d-flex">
          <div class="card work-box flex-fill">
            <div class="card-body">
              <div class="work-icon">
                <span>
                  <img src="@/assets/img/icons/about-hands.svg" alt="img" />
                </span>
              </div>
              <h5>1. Search and Browse</h5>
              <p>
                Customers can browse or search for specific products or services using
                categories, filters, or search bars.
              </p>
              <h4>01</h4>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="card work-box flex-fill">
            <div class="card-body">
              <div class="work-icon">
                <span>
                  <img src="@/assets/img/icons/about-documents.svg" alt="img" />
                </span>
              </div>
              <h5>2 Add to Cart or Book Now</h5>
              <p>
                Customers can add items to their shopping cart. For services, they may
                select a service and proceed to book.
              </p>
              <h4>02</h4>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="card work-box flex-fill">
            <div class="card-body">
              <div class="work-icon">
                <span>
                  <img src="@/assets/img/icons/about-book.svg" alt="img" />
                </span>
              </div>
              <h5>Amazing Places</h5>
              <p>
                The Customer fulfills the order by either providing the service to the
                buyer.
              </p>
              <h4>03</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Work Section -->

  <!-- Choose Us Section -->
  <div class="chooseus-sec">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="choose-content">
            <h2>Why Choose Us</h2>
            <p>Choose us for reliable, personalized service and exceptional results.</p>
            <div class="accordion" id="faq_accordion">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    24/7 Supports
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  class="accordion-collapse collapse show"
                  data-bs-parent="#faq_accordion"
                >
                  <div class="accordion-body">
                    <p>
                      Access round-the-clock support through our dedicated helpdesk,
                      available 24/7 to address any issues or queries you may have.
                      Whether it’s day or night, our team is here to ensure you receive
                      timely assistance and seamless service.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    Client’s reviews
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faq_accordion"
                >
                  <div class="accordion-body">
                    <p>
                      Access round-the-clock support through our dedicated helpdesk,
                      available 24/7 to address any issues or queries you may have.
                      Whether it’s day or night, our team is here to ensure you receive
                      timely assistance and seamless service.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseThree"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseThree"
                  >
                    Professional Team
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseThree"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faq_accordion"
                >
                  <div class="accordion-body">
                    <p>
                      Access round-the-clock support through our dedicated helpdesk,
                      available 24/7 to address any issues or queries you may have.
                      Whether it’s day or night, our team is here to ensure you receive
                      timely assistance and seamless service.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapse4"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseThree"
                  >
                    Best Services
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapse4"
                  class="accordion-collapse collapse"
                  data-bs-parent="#faq_accordion"
                >
                  <div class="accordion-body">
                    <p>
                      Access round-the-clock support through our dedicated helpdesk,
                      available 24/7 to address any issues or queries you may have.
                      Whether it’s day or night, our team is here to ensure you receive
                      timely assistance and seamless service.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="chooseus-img">
            <img src="@/assets/img/services/service-75.jpg" class="img-fluid" alt="img" />
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-xl-3 col-lg-4 col-sm-6">
          <div class="choose-icon">
            <img src="@/assets/img/icons/group-stars.svg" class="img-fluid" alt="img" />
            <div class="choose-info">
              <h3>2583+</h3>
              <p>Satisfied Clients</p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-sm-6">
          <div class="choose-icon">
            <img src="@/assets/img/icons/expert-team.svg" class="img-fluid" alt="img" />
            <div class="choose-info">
              <h3>2583+</h3>
              <p>Expert Team</p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-sm-6">
          <div class="choose-icon">
            <img
              src="@/assets/img/icons/about-documents.svg"
              class="img-fluid"
              alt="img"
            />
            <div class="choose-info">
              <h3>2583+</h3>
              <p>Project Completed</p>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-sm-6">
          <div class="choose-icon border-0">
            <img src="@/assets/img/icons/expereience.svg" class="img-fluid" alt="img" />
            <div class="choose-info">
              <h3>2583+</h3>
              <p>Years of experience</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Choose Us Section -->
</template>
